import { 
  isSameDayString,
  getAppointmentStatusColor,
  isEventInPast,
} from '../../../../utils/calendarUtils.js';
import { DAY_TIME_SLOTS } from '../../../../constants/calendarConstants.js';
import MobileScrollWrapper from './MobileScrollWrapper.js';
import StatusDropdown from '../StatusDropdown.js';
import {
  MobileWeekContainer,
  MobileDayCard,
  MobileDayHeader,
  MobileDayHeaderContent,
  MobileDayTitle,
  MobileDayBadge,
  MobileDayContent,
  MobileAppointmentsTitle,
  MobileAppointmentsList,
  MobileAppointmentCardWithOpacity,
  MobileAppointmentInfo,
  MobileAppointmentName,
  MobileAppointmentTime,
  MobileAppointmentActions,
  MobileNoAppointments,
  MobileAddAppointmentButton,
} from '../../../Css/StyledCalendarMobile.js';

  const MobileWeekView = ({
    weekDays,
    selectedDate,
    weekAppointments = [],
    onTimeSlotClick,
    onStatusChange,
    onAppointmentClick
  }) => {
  const handleTimeSlotClick = (dayDate, timeSlot) => {
    if (onTimeSlotClick) {
      onTimeSlotClick(dayDate, timeSlot);
    }
  };

  const handleStatusChange = (appointmentId, newStatus) => {
    if (onStatusChange) {
      onStatusChange(appointmentId, newStatus);
    }
  };

  const handleAppointmentClick = (appointment) => {
    if (onAppointmentClick) {
      onAppointmentClick(appointment);
    }
  };

  const isPastTimeSlot = (dayDate, timeSlot) => {
    const now = new Date();
    const selectedDateTime = new Date(dayDate);
    const [hours, minutes] = timeSlot.split(':').map(Number);
    
    // Calcular la hora de fin del slot (30 minutos después)
    const endTime = new Date(selectedDateTime);
    endTime.setHours(hours, minutes + 30, 0, 0);
    
    // El slot está en el pasado si la hora actual es mayor que la hora de fin del slot
    return now > endTime;
  };

  // Generar horarios disponibles más inteligentemente (solo algunos horarios comunes)
  const getAvailableTimeSlots = (dayDate) => {
    const commonSlots = DAY_TIME_SLOTS.filter(slot => 
      ['08:00', '09:00', '10:00', '11:00', '12:00', '14:00', '15:00', '16:00', '17:00', '18:00'].includes(slot)
    );
    return commonSlots.filter(slot => !isPastTimeSlot(dayDate, slot));
  };

  return (
    <MobileScrollWrapper>
      <MobileWeekContainer>
      {weekDays.map((day, dayIndex) => {
        const dayAppointments = weekAppointments.filter((appointment) => {
          return isSameDayString(appointment.fecha_turno, day.date);
        });

        const availableSlots = getAvailableTimeSlots(day.date);
        const isToday = selectedDate && day.date.getDate() === selectedDate.getDate();

        return (
          <MobileDayCard key={`mobile-day-${dayIndex}`}>
            {/* Header del día */}
            <MobileDayHeader isToday={isToday}>
              <MobileDayHeaderContent>
                <MobileDayTitle isToday={isToday}>
                  {day.name}
                </MobileDayTitle>
                <MobileDayBadge isToday={isToday}>
                  {day.dateNumber}
                </MobileDayBadge>
              </MobileDayHeaderContent>
            </MobileDayHeader>

            {/* Contenido del día */}
            <MobileDayContent>
              {/* Citas del día */}
              {dayAppointments.length > 0 ? (
                <div>
                  <MobileAppointmentsTitle>
                    Citas programadas ({dayAppointments.length})
                  </MobileAppointmentsTitle>
                  <MobileAppointmentsList>
                    {dayAppointments.map((appointment) => {
                      
                      return (
                        <MobileAppointmentCardWithOpacity
                          key={appointment.id_turno || appointment.id}
                          backgroundColor={getAppointmentStatusColor(appointment.estado, isEventInPast(appointment))}
                          opacity={isEventInPast(appointment) ? 0.7 : 1}
                          onClick={() => handleAppointmentClick(appointment)}
                          style={{ cursor: 'pointer' }}
                        >
                          {/* Lado izquierdo: Nombre completo del paciente y hora de comienzo */}
                          <MobileAppointmentInfo>
                            <MobileAppointmentName>
                              {appointment.paciente_nombre_completo || 'Paciente sin nombre'}
                            </MobileAppointmentName>
                            <MobileAppointmentTime>
                              {appointment.hora_inicio}
                            </MobileAppointmentTime>
                          </MobileAppointmentInfo>

                          {/* Lado derecho: StatusDropdown clickeable */}
                          <MobileAppointmentActions onClick={(e) => e.stopPropagation()}>
                            <StatusDropdown
                              currentStatus={appointment.estado}
                              onStatusChange={handleStatusChange}
                              appointmentId={appointment.id_turno || appointment.id}
                              isSmall={true}
                            />
                          </MobileAppointmentActions>
                        </MobileAppointmentCardWithOpacity>
                      );
                    })}
                  </MobileAppointmentsList>
                </div>
              ) : (
                <MobileNoAppointments>
                  Sin citas programadas
                </MobileNoAppointments>
              )}

              {/* Botón para agregar cita rápida */}
              {availableSlots.length > 0 && (
                <MobileAddAppointmentButton
                  onClick={() => {
                    // Seleccionar el primer horario disponible
                    const firstSlot = availableSlots[0];
                    handleTimeSlotClick(day.date, firstSlot);
                  }}
                >
                  + Agregar cita
                </MobileAddAppointmentButton>
              )}
            </MobileDayContent>
          </MobileDayCard>
        );
      })}
      </MobileWeekContainer>
    </MobileScrollWrapper>
  );
};

export default MobileWeekView;